// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{
    value: string;
}>;

export const DispatchSetCustomerNumber: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/ContactUs/SetCustomerNumber",
        value: props.parameter.value,
    });
};

export const chain = [DispatchSetCustomerNumber];
const SetCustomerNumber = createHandlerChainRunner(chain, "setCustomerNumber");
export default SetCustomerNumber;
